import React from 'react';
import './Whatsapp.css';

const Whatsapp = () => {
    const numero = '5491156067007';
    const mensaje = '¡Hola! Quiero más información.';

    const link = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

    return (
        <a
            href={link}
            className="boton-wsp"
            target="_blank"
            rel="noopener noreferrer"
        >
            <img
                src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                alt="WhatsApp"
            />
        </a>
    );
};

export default Whatsapp;
